import React from "react";
import { Card, CardContent, CardHeader, CardTitle } from "../../../ui/card";
import { Input } from "../../../ui/input";

import { Label } from "../../../ui/label";
import { FileTextIcon, InfoIcon } from "lucide-react";

interface DatasetNameProps {
  name?: string;
  description?: string;
  onChange: (name: string, description: string) => void;
}

const DatasetName: React.FC<DatasetNameProps> = ({
  name,
  description,
  onChange,
}) => {
  return (
    <div className="space-y-8">
      {/* Header */}
      <div className="text-center space-y-3">
        <h2 className="text-2xl font-gc-demi-bold text-foreground">
          Dataset Details
        </h2>
        <p className="text-muted-foreground font-gc-reg">
          Enter a name and description for your dataset
        </p>
      </div>

      {/* Form Card */}
      <Card className="border-border">
        <CardHeader className="pb-4">
          <CardTitle className="flex items-center gap-2 text-lg font-gc-med text-foreground">
            <FileTextIcon className="w-5 h-5 text-maitai-green" />
            Basic Information
          </CardTitle>
        </CardHeader>
        <CardContent className="space-y-6">
          <div className="space-y-3">
            <div className="flex items-center gap-2">
              <Label htmlFor="dataset-name" className="text-sm font-gc-med text-foreground">
                Name
              </Label>
              <span className="text-red-500 text-sm">*</span>
            </div>
            <Input
              id="dataset-name"
              value={name || ""}
              onChange={(e) => onChange(e.target.value, description || "")}
              placeholder="Enter dataset name"
              className="w-full"
            />
            <p className="text-xs text-muted-foreground">
              A unique name for your dataset
            </p>
          </div>

          <div className="space-y-3">
            <div className="flex items-center gap-2">
              <Label htmlFor="dataset-description" className="text-sm font-gc-med text-foreground">
                Description
              </Label>
              <span className="text-red-500 text-sm">*</span>
            </div>
            <textarea
              id="dataset-description"
              value={description || ""}
              onChange={(e: React.ChangeEvent<HTMLTextAreaElement>) => onChange(name || "", e.target.value)}
              placeholder="Enter dataset description"
              rows={4}
              className="flex min-h-[80px] w-full rounded-md border border-input bg-background px-3 py-2 text-sm ring-offset-background placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50"
            />
            <p className="text-xs text-muted-foreground">
              Provide a brief description of this dataset and its intended use
            </p>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default DatasetName; 